<template>
  <div class="homePage pageContainer">
    <p>
     <span class="username">
        {{userName}}
     </span>
      <span>
        欢迎来到官网后台管理系统
      </span>
    </p>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  
  export default {
    name: 'home',
    computed: {
      ...mapGetters([
        'userName'
      ])
    }
  };
</script>

<style lang="scss">
  .homePage {
    font-size: 16px;
    
    .username {
      color: #4A78FF;
    }
  }
</style>
